import GeneratedVirtualMailboxStore from "./generated/GeneratedVirtualMailboxStore"

class VirtualMailboxStore extends GeneratedVirtualMailboxStore {

}

export const virtualMailboxStore = new VirtualMailboxStore()
